import { render } from "./ContactArea.vue?vue&type=template&id=df128bea&scoped=true"
import script from "./ContactArea.vue?vue&type=script&lang=js"
export * from "./ContactArea.vue?vue&type=script&lang=js"

import "./ContactArea.vue?vue&type=style&index=0&id=df128bea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df128bea"]])

export default __exports__